// Central product identity. Change these (plus public/manifest.json and public/brand/*) when the final brand is approved.
export const BRAND = {
  appName: "FILIT Compliance Hub",
  shortName: "FILIT",
  icon: "/brand/icon-192.png",
  logo: "/brand/filit-logo-512.png",
  copyright: "© 2026 V.A Business Consultants. All rights reserved.",
};

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || window.location.protocol !== "https:") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      reg.addEventListener("updatefound", () => {
        const w = reg.installing;
        w?.addEventListener("statechange", () => { if (w.state === "installed" && navigator.serviceWorker.controller) w.postMessage("SKIP_WAITING"); });
      });
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    }).catch(() => {});
  });
}
